/* eslint-disable no-magic-numbers */

import { DescriptionList } from '@omnipresentgroup/design-system';
import type { BaseQuote, InvoiceQuote } from '@omnipresentgroup/types';

import { QuoteSkeleton } from './components';
import { useQuoteDescriptionList } from './hooks';

type Props =
  | {
      invoiceQuote?: never;
      quoteSummary?: BaseQuote;
      loading?: boolean;
    }
  | { quoteSummary?: never; invoiceQuote?: InvoiceQuote; loading?: boolean };

export const ContractorInvoiceQuote = ({
  invoiceQuote,
  quoteSummary,
  loading,
}: Props) => {
  const quote = invoiceQuote || quoteSummary;
  const { descriptionListItems, isLoading: isQuoteDescriptionLoading } =
    useQuoteDescriptionList(quote, !!invoiceQuote);
  return loading || isQuoteDescriptionLoading ? (
    <QuoteSkeleton />
  ) : (
    <DescriptionList id="summary" list={descriptionListItems} border={false} />
  );
};
